(function () {
  if (window.__khShareBound) return;
  window.__khShareBound = true;

  function khToast(message) {
    var existing = document.getElementById('kh-share-toast');
    if (existing) existing.parentNode.removeChild(existing);
    var el = document.createElement('div');
    el.id = 'kh-share-toast';
    el.textContent = message;
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add('kh-share-toast--visible');
    });
    setTimeout(function () {
      el.classList.remove('kh-share-toast--visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }, 2600);
  }

  function khCopyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        resolve();
      } catch (err) {
        reject(err);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest ? e.target.closest('[data-kh-copy-link]') : null;
    if (copyBtn) {
      e.preventDefault();
      var link = copyBtn.getAttribute('data-kh-copy-link');
      khCopyText(link).then(function () {
        khToast('Link copied!');
      }).catch(function () {
        khToast('Could not copy link — copy it from the address bar instead.');
      });
      return;
    }

    var igBtn = e.target.closest ? e.target.closest('[data-kh-instagram-share]') : null;
    if (igBtn) {
      e.preventDefault();
      var igLink = igBtn.getAttribute('data-kh-instagram-share');
      khCopyText(igLink).then(function () {
        khToast('Link copied — paste it in your Instagram bio, story, or DM.');
      }).catch(function () {
        khToast('Could not copy link — copy it from the address bar instead.');
      });
      var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
      if (isMobile) {
        setTimeout(function () {
          window.location.href = 'instagram://app';
        }, 600);
      }
      return;
    }
  });
})();
